export default "__VITE_ASSET__Cmr2Kqgj__"